<script lang="ts" setup>
import { computed } from 'vue';
import { AppTypography } from '~/components/base';

// Each entity has its own illustration — they are NOT interchangeable.
const ILLUSTRATIONS = {
  result: { src: '/no-result.svg', width: 217, height: 178 },
  candidates: { src: '/no-candidates.svg', width: 195, height: 166 },
  parties: { src: '/no-parties.svg', width: 195, height: 166 },
  campaigns: { src: '/no-campaigns.svg', width: 217, height: 178 },
} as const;

export type EmptyStateIllustration = keyof typeof ILLUSTRATIONS;

const {
  title,
  illustration,
  description = 'Check the spelling or try broader keywords.',
} = defineProps<{
  title: string;
  illustration: EmptyStateIllustration;
  description?: string;
}>();

const asset = computed(() => ILLUSTRATIONS[illustration]);
</script>

<template>
  <div class="empty-state flex flex-col items-center gap-3 text-center">
    <img
      :src="asset.src"
      :width="asset.width"
      :height="asset.height"
      alt=""
      aria-hidden="true"
      class="empty-state__illustration"
    />
    <AppTypography type="title-6">{{ title }}</AppTypography>
    <AppTypography v-if="description" type="body" class="text-color-tertiary">
      {{ description }}
    </AppTypography>
  </div>
</template>

<style scoped lang="scss">
.empty-state {
  padding: $spacing-6xl $spacing-lg;

  &__illustration {
    width: 100%;
    max-width: 217px;
    height: auto;
  }
}
</style>
